import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { SidebarProvider } from "./context/SidebarContext";

let root = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <SidebarProvider>
      <App />
    </SidebarProvider>
  </Provider>,
  root
);

